@if (messages.length > 0) {
<button class="btn btn-gradient clear-chat-history" (click)="clearChatHistory()">Clear History</button>
}
<div class="chat-conversation">
    @for (message of messages; track message; let i = $index) {
    <div>
        @if (message.sender == 'ChatBot') {
        <div class="chat chat-start p-3">
            <div class="chat-image avatar">
                <div class="w-10 rounded-full">

                </div>
            </div>
            <div class="chat-header">
                {{ nodelsConfig[ message.destination! ]?.name || 'AI' }}
                <time class="text-xs opacity-50">{{ message.timestamp | date }}</time>
            </div>
            <div class="chat-bubble-container flex gap-2">
                <div class="chat-content">
                    <div class="chat-bubble custom-bubble text-white break-all max-w-lg pointer" (click)="onMessageClick(message)">
                        @if (message.status == 'waiting') {
                        <div class="typing-indicator">
                            <div class="dot-flashing"></div>
                        </div>
                        } @else {
                        @if (message.showTyping) {
                        <div style="position: relative;">
                            <div [innerHTML]="message.content | safe: 'html'" style="visibility: hidden; height: 1px; overflow: visible;"></div>
                            <ngx-typed-writer [strings]="[message.content]" [typeSpeed]="10" (completeLoop)="onTypingFinish(message)" [loop]="false" isHTML="true"></ngx-typed-writer>
                            <div [innerHTML]="message.references ?? '' | safe: 'html'"></div>
                        </div>
                        } @else {
                        <div [innerHTML]="message.content + (message.references ?? '') | safe: 'html'"></div>
                        }
                        }
                    </div>
                </div>
            </div>
        </div>
        }
        @if (message.sender === 'User') {
        <div class="chat chat-end p-3">
            <div class="chat-image avatar">
                <div class="w-10 rounded-full">

                </div>
            </div>
            <div class="chat-header">
                <time class="text-xs opacity-50">{{ message.timestamp | date }}</time>
            </div>
            <div class="chat-bubble-container relative" (click)="loadBackIntoPrompt(message)">
                <div class="chat-bubble text-white break-all max-w-lg">
                    {{ message.content }}
                </div>
            </div>
            <div class="chat-footer opacity-50">
                {{ message.status | titlecase }}
            </div>
        </div>
        }
    </div>
    }
</div>
<div #bottom></div>

<div class="input-wrapper">
    <div class="input-group" ngbDropdown>
        @if (articleID > 0) {
        <button class="btn btn-outline-primary" (click)="openDocketSearch()"
            [ngbPopover]="docketSearchBodyContent" [popoverTitle]="docketSearchTitleContent" popoverClass="docket-search-pop" autoClose="outside">
            <i-bs [name]="iconNames.Search"></i-bs>Docket
        </button>
        @if (docketNumbers.length > 0) {
        @for (docket of docketNumbers; track docket.docketid) {
        <div class="input-group-text" id="btnGroupAddon">
            <button class="btn btn-outline-primary btn-sm">
                {{docket.docketid}}
                <i-bs [name]="iconNames.InfoCircle" [ngbPopover]="docketPopBodyContent" [popoverTitle]="docketPopTitleContent" [popoverContext]="{docket}" triggers="mouseenter:mouseleave" popoverClass="docket-pop"></i-bs>
                <i-bs [name]="iconNames.X" (click)="removeDocket(docket.docketid)"></i-bs>
            </button>
        </div>
        }
        }
        }
        <input #messageContentInput [(ngModel)]="messageContent" type="text" placeholder="Send a message..." (keydown.enter)="sendMessage()" class="form-control">
        <button type="button" class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle>
            {{nodelsConfig[agentInUse]?.name}}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            @for (model of nodelsConfig | keyvalue; track model.key) {
            @if (model.value.enabled) {
            <button ngbDropdownItem (click)="agentInUse = model.key">{{model.value.name}}</button>
            } @else {
            <button ngbDropdownItem [disabled]="true">{{model.value.name}} - coming soon</button>
            }
            }
        </div>
        <button class="btn btn-bankruptcydata" type="button" (click)="sendMessage()">
            <i-bs [name]="iconNames.SendCheck"></i-bs>
        </button>
    </div>
</div>

<ng-template #docketPopTitleContent let-docket="docket">
    <div class="d-flex justify-content-between">
        <div class="d-flex">{{docket.docketid}}</div>
        <div class="d-flex">{{docket.pubDate}}</div>
    </div>
</ng-template>

<ng-template #docketPopBodyContent let-docket="docket">
    <div style="width: 290px;">{{docket.description}}</div>
</ng-template>

<ng-template #docketSearchTitleContent let-docket="docket">
    <div class="d-flex justify-content-between">
        <div class="d-flex">Search</div>
        <div class="d-flex">
            @if (!docketsForSearchLoading) {
                {{docketsForSearch.length}} dockets
            }
        </div>
    </div>
</ng-template>

<ng-template #docketSearchBodyContent let-docket="docket">
    <div class="row">
        <div class="col-12">
            <div class="input-group">
                <input #docketContentInput [(ngModel)]="docketSearchContent" type="text" placeholder="Search by name or docket number" (keyup)="docketSearch()" class="form-control">
                <button class="btn btn-outline-primary" type="button">
                    <i-bs [name]="iconNames.Search"></i-bs>
                </button>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12" style="height: 380px; overflow-y: hidden;">
            <ng-scrollbar class="ngr-scrollbar"  visibility="visible" orientation="vertical" #chatBody="ngScrollbar">
                @if (docketsForSearchLoading) {
                    <ngb-progressbar [value]="100" [striped]="true" [animated]="true" class="mt-2"></ngb-progressbar>
                } @else {
                <table class="table table-bordered table-hover">
                    <tbody>
                @for (docket of docketsForSearch; track docket.docketid) {
                    @if (docket.visible) {
                        <tr (click)="onDocketSelected(docket)">
                            <div class="docket-item">
                                <div>{{ docket.docketid }} - {{ docket.pubDate }}</div>
                                <div>{{ docket.description }}</div>
                            </div>
                        </tr>
                }
                }
                    </tbody>
                </table>
                }
            </ng-scrollbar>
        </div>
    </div>
</ng-template>